import { Field } from './field';

export class ProcessField {
  id: string | undefined;
  formField: Field | undefined;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  content: any;
  check: string;

  constructor() {
    this.check = '';
  }
}
